export default __webpack_public_path__ + "static/media/Download.5b861e55.svg";